module.exports = __webpack_public_path__ + "static/media/brownBookSmall.bbc64e39.png";